import { Link } from "react-router-dom";

function Computerlab() {
  return (
    <>
      <div className="innerslide py-3 bg-light border-bottom">
        <ul className="breadcrumb container mb-0">
          <li className="breadcrumb-item">
            <Link to="/">Home</Link>
          </li>
          <li className="breadcrumb-item"> Facilities</li>
          <li className="breadcrumb-item active"> Computer Lab</li>
        </ul>
      </div>
      <div className="innersec container my-5">
        <div className="row g-3 facilities_section_imgs">
          <div class="col-lg-12">
            <h1> Computer Lab </h1>
            <p>
              The Computer Lab at Frank Anthony School, Bangalore, is a modern,
              well-equipped facility that allows students to learn and explore
              the world of computers and technology. The lab has computers with
              updated software, internet access, and other digital resources to
              help students practice coding, programming, and multimedia skills.
              Students are encouraged to work on projects, learn digital tools,
              and develop problem-solving and technical skills under the
              guidance of experienced teachers.
            </p>
          </div>
        </div>
        <br />
        <div className="row g-3 facilities_section_imgs">
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
            <img
              src="https://webapi.entab.info/api/image/FAJUNIORSB/public/Images/com-1.jpeg"
              alt="Frank Anthony Bangalore"
              className="img-fluid"
            />
          </div>
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
            <img
              src="https://webapi.entab.info/api/image/FAJUNIORSB/public/Images/com-2.jpeg"
              alt="Frank Anthony Bangalore"
              className="img-fluid"
            />
          </div>
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
            <img
              src="https://webapi.entab.info/api/image/FAJUNIORSB/public/Images/com-3.jpeg"
              alt="Frank Anthony Bangalore"
              className="img-fluid"
            />
          </div>
        </div>
      </div>
    </>
  );
}
export default Computerlab;
